/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-b011b919.mjs';
import { defineComponent, toRefs, computed, createVNode, mergeProps } from 'vue';
import { c as camelCase_1 } from '../_chunks/dep-f50ac97c.mjs';
import { g as get_1 } from '../_chunks/dep-548864ce.mjs';
import { p as pick_1 } from '../_chunks/dep-9c5bd9e6.mjs';
import TrElement, { ROW_LISTENERS, TABLE_PROPS } from './tr.mjs';
import '../hooks/useConfig.mjs';
import { useTNodeJSX } from '../hooks/tnode.mjs';
import useClassName from './hooks/useClassName.mjs';
import baseTableProps from './base-table-props.mjs';
import useRowspanAndColspan from './hooks/useRowspanAndColspan.mjs';
import { useConfig } from '../config-provider/useConfig.mjs';
import '../_chunks/dep-ae1abe1d.mjs';
import '../_chunks/dep-eba62589.mjs';
import '../_chunks/dep-94585de3.mjs';
import '../_chunks/dep-7d9e11c8.mjs';
import '../_chunks/dep-b9567f6a.mjs';
import '../_chunks/dep-654b4b01.mjs';
import '../_chunks/dep-06221fe2.mjs';
import '../_chunks/dep-a6022780.mjs';
import '../_chunks/dep-d7053a2c.mjs';
import '../_chunks/dep-f3e3393e.mjs';
import '../_chunks/dep-0fa7026c.mjs';
import '../_chunks/dep-31dc9d09.mjs';
import '../_chunks/dep-30c9b83d.mjs';
import '../_chunks/dep-8f44163a.mjs';
import '../_chunks/dep-a255de71.mjs';
import '../_chunks/dep-8d19eb1a.mjs';
import '../_chunks/dep-16e2f1a5.mjs';
import '../_chunks/dep-ebe8bc2f.mjs';
import '../_chunks/dep-cc371884.mjs';
import '../_chunks/dep-f2586304.mjs';
import '../_chunks/dep-1f0070bb.mjs';
import '../_chunks/dep-9d0d32fd.mjs';
import '../_chunks/dep-e05e20e6.mjs';
import '../_chunks/dep-ebfafd52.mjs';
import '../_chunks/dep-750294df.mjs';
import '../_chunks/dep-f7eab885.mjs';
import '../_chunks/dep-67dfe9c7.mjs';
import '../_chunks/dep-1041f7d7.mjs';
import '../_chunks/dep-7f2f03b4.mjs';
import './utils.mjs';
import './hooks/useFixed.mjs';
import '../_chunks/dep-fc63c737.mjs';
import '../_chunks/dep-2a2a0e63.mjs';
import '../_chunks/dep-fdde96c5.mjs';
import '../_chunks/dep-83588d06.mjs';
import '../_chunks/dep-63c5b255.mjs';
import '../_common/js/log/index.mjs';
import '../_common/js/log/log.mjs';
import '../_common/js/utils/getScrollbarWidth.mjs';
import '../_common/js/utils/helper.mjs';
import '../_chunks/dep-56ceb7ce.mjs';
import '../_chunks/dep-c3626417.mjs';
import '../_chunks/dep-e00db566.mjs';
import '../_chunks/dep-961339ce.mjs';
import '../utils/dom.mjs';
import '../utils/easing.mjs';
import './ellipsis.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-ff1c0573.mjs';
import '../_chunks/dep-42be3824.mjs';
import '../_chunks/dep-a11a63ea.mjs';
import '../_chunks/dep-ad1accf9.mjs';
import '../_chunks/dep-3e3494dc.mjs';
import '../_chunks/dep-b9d74a58.mjs';
import '../tooltip/index.mjs';
import '../tooltip/tooltip.mjs';
import '../_chunks/dep-219a3220.mjs';
import '../_chunks/dep-bd3d75f1.mjs';
import '../_chunks/dep-2b8d75e2.mjs';
import '../_chunks/dep-b32fb318.mjs';
import '../tooltip/props.mjs';
import '../popup/props.mjs';
import '../popup/index.mjs';
import '../popup/popup.mjs';
import '@popperjs/core';
import '../_common/js/utils/set-style.mjs';
import '../popup/container.mjs';
import '../hooks/useResizeObserver.mjs';
import '../hooks/useVModel.mjs';
import '../_chunks/dep-adebe2ce.mjs';
import '../_chunks/dep-a0bd2e3a.mjs';
import '../_chunks/dep-91208ac3.mjs';
import '../_chunks/dep-9b57842b.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-99a0abba.mjs';
import '../_chunks/dep-9d5ee0e1.mjs';
import '../config-provider/type.mjs';
import '../utils/withInstall.mjs';
import './style/css.mjs';
import '../popup/type.mjs';
import '../tooltip/util.mjs';
import '../tooltip/type.mjs';
import './hooks/useLazyLoad.mjs';
import '../_common/js/utils/observe.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ROW_AND_TD_LISTENERS = ROW_LISTENERS.concat("cell-click");
var extendTableProps = ["rowKey", "rowClassName", "rowAttributes", "loading", "empty", "fixedRows", "firstFullRow", "lastFullRow", "rowspanAndColspan", "scroll", "cellEmptyContent", "pagination", "attach", "onCellClick", "onPageChange", "onRowClick", "onRowDblclick", "onRowMouseover", "onRowMousedown", "onRowMouseenter", "onRowMouseleave", "onRowMouseup", "onScroll", "onScrollX", "onScrollY"];
var TBody = defineComponent({
  name: "TBody",
  props: _objectSpread({
    classPrefix: String,
    data: Array,
    columns: Array,
    ellipsisOverlayClassName: String,
    rowAndColFixedPosition: Map,
    showColumnShadow: Object,
    tableElm: {},
    tableWidth: Number,
    isWidthOverflow: Boolean,
    virtualConfig: Object,
    tableContentElm: {},
    handleRowMounted: Function,
    renderExpandedRow: Function,
    firstFullRow: [String, Function],
    lastFullRow: [String, Function]
  }, pick_1(baseTableProps, extendTableProps)),
  setup: function setup(props) {
    var renderTNode = useTNodeJSX();
    var _toRefs = toRefs(props),
      data = _toRefs.data,
      columns = _toRefs.columns,
      rowKey = _toRefs.rowKey,
      rowspanAndColspan = _toRefs.rowspanAndColspan;
    var _useConfig = useConfig("table"),
      t = _useConfig.t,
      globalConfig = _useConfig.globalConfig;
    var _useClassName = useClassName(),
      tableFullRowClasses = _useClassName.tableFullRowClasses,
      tableBaseClass = _useClassName.tableBaseClass;
    var _useRowspanAndColspan = useRowspanAndColspan(data, columns, rowKey, rowspanAndColspan),
      skipSpansMap = _useRowspanAndColspan.skipSpansMap;
    var tbodyClasses = computed(function () {
      return [tableBaseClass.body];
    });
    return {
      t: t,
      globalConfig: globalConfig,
      renderTNode: renderTNode,
      tableFullRowClasses: tableFullRowClasses,
      tbodyClasses: tbodyClasses,
      tableBaseClass: tableBaseClass,
      skipSpansMap: skipSpansMap
    };
  },
  render: function render() {
    var _this = this,
      _this$data,
      _this$data2,
      _this$virtualConfig,
      _this$virtualConfig2;
    var renderEmpty = function renderEmpty(columns) {
      return createVNode("tr", {
        "class": [_this.tableBaseClass.emptyRow, _defineProperty({}, _this.tableFullRowClasses.base, _this.isWidthOverflow)]
      }, [createVNode("td", {
        "colspan": columns.length
      }, [createVNode("div", {
        "class": [_this.tableBaseClass.empty, _defineProperty({}, _this.tableFullRowClasses.innerFullRow, _this.isWidthOverflow)],
        "style": _this.isWidthOverflow ? {
          width: "".concat(_this.tableWidth, "px")
        } : {}
      }, [_this.renderTNode("empty") || _this.t(_this.globalConfig.empty)])])]);
    };
    var getFullRow = function getFullRow(columnLength2, type) {
      var tType = camelCase_1(type);
      var fullRowNode = _this.renderTNode(tType);
      if (["", null, void 0, false].includes(fullRowNode)) return null;
      var isFixedToLeft = _this.isWidthOverflow && _this.columns.find(function (col) {
        return col.fixed === "left";
      });
      var classes = [_this.tableFullRowClasses.base, _this.tableFullRowClasses[tType]];
      return createVNode("tr", {
        "class": classes,
        "key": "key-full-row-".concat(type)
      }, [createVNode("td", {
        "colspan": columnLength2
      }, [createVNode("div", {
        "class": _defineProperty({}, _this.tableFullRowClasses.innerFullRow, isFixedToLeft),
        "style": isFixedToLeft ? {
          width: "".concat(_this.tableWidth, "px")
        } : {}
      }, [createVNode("div", {
        "class": _this.tableFullRowClasses.innerFullElement
      }, [fullRowNode])])])]);
    };
    var columnLength = this.columns.length;
    var dataLength = this.data.length;
    var trNodeList = [];
    var properties = ["classPrefix", "ellipsisOverlayClassName", "rowAndColFixedPosition", "scroll", "tableElm", "tableContentElm", "pagination", "attach"];
    (_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data.forEach(function (row, rowIndex) {
      var trProps = _objectSpread(_objectSpread({}, pick_1(_this.$props, TABLE_PROPS)), {}, {
        rowKey: _this.rowKey || "id",
        row: row,
        columns: _this.columns,
        rowIndex: row.__VIRTUAL_SCROLL_INDEX || rowIndex,
        dataLength: dataLength,
        skipSpansMap: _this.skipSpansMap,
        virtualConfig: _this.virtualConfig
      }, pick_1(_this.$props, properties));
      if (_this.onCellClick) {
        trProps.onCellClick = _this.onCellClick;
      }
      var trNode = createVNode(TrElement, mergeProps({
        "key": get_1(row, _this.rowKey || "id") || rowIndex
      }, trProps, {
        "onRowMounted": _this.handleRowMounted
      }), _this.$slots);
      trNodeList.push(trNode);
      if (_this.renderExpandedRow) {
        var p = {
          row: row,
          index: rowIndex,
          columns: _this.columns,
          tableWidth: _this.tableWidth,
          isWidthOverflow: _this.isWidthOverflow
        };
        var expandedContent = _this.renderExpandedRow(p);
        expandedContent && trNodeList.push(expandedContent);
      }
    });
    var list = [getFullRow(columnLength, "first-full-row")].concat(trNodeList, [getFullRow(columnLength, "last-full-row")]);
    var isEmpty = !((_this$data2 = this.data) !== null && _this$data2 !== void 0 && _this$data2.length) && !this.loading && !this.firstFullRow && !this.lastFullRow;
    var translate = "translateY(".concat((_this$virtualConfig = this.virtualConfig) === null || _this$virtualConfig === void 0 ? void 0 : _this$virtualConfig.translateY.value, "px)");
    var posStyle = (_this$virtualConfig2 = this.virtualConfig) !== null && _this$virtualConfig2 !== void 0 && _this$virtualConfig2.isVirtualScroll.value ? {
      transform: translate,
      "-ms-transform": translate,
      "-moz-transform": translate,
      "-webkit-transform": translate
    } : void 0;
    return createVNode("tbody", {
      "class": this.tbodyClasses,
      "style": _objectSpread({}, posStyle)
    }, [isEmpty ? renderEmpty(this.columns) : list]);
  }
});

export { ROW_AND_TD_LISTENERS, TBody as default, extendTableProps };
//# sourceMappingURL=tbody.mjs.map
